import { api } from 'shared/api'
import { UserFieldsSchemas } from 'shared/api/requests/customFields/schemas'

export const UserFieldsApi = {
  moveToFolder: api.account.createPost({
    url: '/customFields/moveToFolder',
    schemas: UserFieldsSchemas.moveToFolder,
  }),
  moveToFolderBulk: api.account.createPost({
    url: '/customFields/moveToFolderBulk',
    schemas: UserFieldsSchemas.moveToFolderBulk,
  }),
  getFolderContentCount: api.account.createGet({
    url: '/customFields/getFolderContentCount',
    schemas: UserFieldsSchemas.getFolderContentCount,
  }),
  list: api.account.createGet({
    url: '/customFields/list',
    schemas: UserFieldsSchemas.listSchema,
  }),
  create: api.account.createPost({
    url: '/customFields/create',
    schemas: UserFieldsSchemas.createSchema,
  }),
  save: api.account.createPost({
    url: '/customFields/update',
    schemas: UserFieldsSchemas.updateSchema,
  }),
  archive: api.account.createPost({
    url: '/customFields/archive',
    schemas: UserFieldsSchemas.archiveSchema,
  }),
  restore: api.account.createPost({
    url: '/customFields/restore',
    schemas: UserFieldsSchemas.restoreSchema,
  }),
  delete: api.account.createPost({
    url: '/customFields/delete',
    schemas: UserFieldsSchemas.deleteSchema,
  }),
  setSubscriberField: api.account.createPost({
    url: '/subscribers/setCustomField',
    schemas: UserFieldsSchemas.setSubscriberFieldSchema,
  }),
  setSystemField: api.account.createPost({
    url: '/subscribers/setSystemField',
    schemas: UserFieldsSchemas.setSystemFieldSchema,
  }),
  getEntitiesList: api.account.createGet({
    url: '/customFields/getUsesList',
    schemas: UserFieldsSchemas.getEntitiesListSchema,
  }),
  archiveBulk: api.account.createPost({
    url: '/customFields/archiveBulk',
    schemas: UserFieldsSchemas.archiveBulkSchema,
  }),
  deleteBulk: api.account.createPost({
    url: '/customFields/deleteBulk',
    schemas: UserFieldsSchemas.deleteBulkSchema,
  }),
  restoreBulk: api.account.createPost({
    url: '/customFields/restoreBulk',
    schemas: UserFieldsSchemas.restoreBulkSchema,
  }),
}
